import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { LoginComponent } from './login.component';
import { LoginService }   from './login.service';
import { LoginStates }    from './login.states';
import { MessagesModule } from '../../app-lite/messages/messages.module';
import { SharedModule }   from '../../app-lite/shared/shared.module';
import { XeroModule }     from '../xero/xero.module';

@NgModule({
  declarations: [
    LoginComponent
  ],
  entryComponents: [
    LoginComponent
  ],
  imports: [
    MessagesModule,
    SharedModule,
    XeroModule,

    UIRouterUpgradeModule.forChild({ states: LoginStates })
  ],
  providers: [
    LoginService
  ]
})
export class LoginModule {}
